"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeZone = void 0;
var TimeZone;
(function (TimeZone) {
    /**
     * Asuncion, Paraguay (PYT/PYST)
     */
    TimeZone["AmericaAsuncion"] = "America/Asuncion";
    /**
     * Bogota, Colombia (COT)
     */
    TimeZone["AmericaBogota"] = "America/Bogota";
    /**
     * Buenos Aires, Argentina (ART)
     */
    TimeZone["AmericaBuenosAires"] = "America/Buenos_Aires";
    /**
     * Lima, Peru (PET)
     */
    TimeZone["AmericaLima"] = "America/Lima";
    /**
     * Mexico City, Mexico (CST/CDT)
     */
    TimeZone["AmericaMexico"] = "America/Mexico_City";
    /**
     * Montevideo, Uruguay (UYT)
     */
    TimeZone["AmericaMontevideo"] = "America/Montevideo";
    /**
     * New York, USA (EST/EDT)
     */
    TimeZone["AmericaNewYork"] = "America/New_York";
    /**
     * Santiago, Chile (CLT/CLST)
     */
    TimeZone["AmericaSantiago"] = "America/Santiago";
    /**
     * São Paulo, Brazil (BRT/BRST)
     */
    TimeZone["AmericaSaoPaulo"] = "America/Sao_Paulo";
    /**
     * Ottawa, Canada (EST/EDT)
     */
    TimeZone["AmericaToronto"] = "America/Toronto";
    /**
     * Washington, D.C., USA (EST/EDT)
     */
    TimeZone["AmericaWashington"] = "America/Washington_DC";
    /**
     * Kolkata, India (IST)
     */
    TimeZone["AsiaKolkata"] = "Asia/Kolkata";
    /**
     * Lagos, Nigeria (WAT)
     */
    TimeZone["AfricaLagos"] = "Africa/Lagos";
    /**
     * London, United Kingdom (GMT/BST)
     */
    TimeZone["EuropeLondon"] = "Europe/London";
    /**
     * Madrid, Spain (CET/CEST)
     */
    TimeZone["EuropeSpain"] = "Europe/Madrid";
    /**
     * Lisbon, Portugal (WET/WEST)
     */
    TimeZone["EuropeLisbon"] = "Europe/Lisbon";
    /**
     * Paris, France (CET/CEST)
     */
    TimeZone["EuropeParis"] = "Europe/Paris";
    /**
     * Berlin, Germany (CET/CEST)
     */
    TimeZone["EuropeBerlin"] = "Europe/Berlin";
    /**
     * Rome, Italy (CET/CEST)
     */
    TimeZone["EuropeRome"] = "Europe/Rome";
    /**
     * Ecuador (ECT)
     */
    TimeZone["AmericaGuayaquil"] = "America/Guayaquil";
})(TimeZone || (exports.TimeZone = TimeZone = {}));
//# sourceMappingURL=timezone.js.map